export const SETTINGS = {
  WHATSAPP: 'WHATSAPP',
  NOTIFICATION: 'NOTIFICATION',
  INSTALL: 'INSTALL',
};
export default {};
